import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartDepartmentFieldPack: FieldPack = {
  id: 'orgchart-department',
  name: 'Department Fields',
  description: 'Department entity fields carrying aggregate data for workforce planning and reorg',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Department Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'code',
      label: 'Department Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 90,
      sensitivity: 'public',
    },
    {
      id: 'parentDepartmentId',
      label: 'Parent Department',
      type: FieldType.TEXT,
      tags: ['organization'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'headPositionId',
      label: 'Department Head',
      type: FieldType.TEXT,
      tags: ['organization'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'headName',
      label: 'Head Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 75,
      sensitivity: 'public',
    },
    {
      id: 'costCenter',
      label: 'Cost Center',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 70,
      sensitivity: 'internal',
    },
    {
      id: 'location',
      label: 'Primary Location',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization', 'location'],
      priority: 65,
      sensitivity: 'public',
    },
    {
      id: 'headcount',
      label: 'Headcount',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 60,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'targetHeadcount',
      label: 'Target Headcount',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 55,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'totalFTE',
      label: 'Total FTE',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 50,
      min: 0,
      step: 0.1,
      sensitivity: 'internal',
    },
    {
      id: 'budget',
      label: 'Annual Budget',
      type: FieldType.NUMBER,
      tags: ['compensation'],
      priority: 45,
      min: 0,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'budgetUtilization',
      label: 'Budget Utilization (%)',
      type: FieldType.NUMBER,
      tags: ['compensation'],
      priority: 40,
      min: 0,
      max: 200,
      step: 0.1,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'vacancies',
      label: 'Open Positions',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 35,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'avgTenure',
      label: 'Average Tenure',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 30,
      min: 0,
      step: 0.1,
      sensitivity: 'internal',
    },
    {
      id: 'attritionRate',
      label: 'Attrition Rate (%)',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 25,
      min: 0,
      max: 100,
      step: 0.1,
      sensitivity: 'manager',
    },
    {
      id: 'functionType',
      label: 'Function Type',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 10,
      options: [
        { value: 'revenue', label: 'Revenue-Generating' },
        { value: 'support', label: 'Support/Overhead' },
        { value: 'shared', label: 'Shared Services' },
      ],
      sensitivity: 'public',
    },
  ],
};
